module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-a5dfcd585ce16fa48a2677f5880d9c35.webp";